import styled from 'styled-components';

export const TabLink = styled.button`
  position: relative;
  padding: 9px 12px 6px;
  border: 1px solid ${({ theme, selected }) => (selected ? theme.borderColor : 'transparent')};
  border-radius: 4px 4px 0 0;
  background: ${({ selected }) => (selected ? '#fff' : 'transparent')};
  color: ${({ theme }) => theme.colors.font};

  ${({ theme, selected }) =>
    (selected
      ? `
    &:before {
      position: absolute;
      top: -1px;
      left: -1px;
      right: -1px;
      height: 3px;
      content: '';
      border-radius: 4px 4px 2px 2px;
      background-color: ${theme.mainColor};
    }

    &:after {
      position: absolute;
      bottom: -1px;
      left: 0;
      right: 0px;
      height: 1px;
      content: '';
      background-color: #fff;
    }
  `
      : null)};

  &:first-of-type {
    left: -1px;
  }

  &:last-of-type {
    right: -1px;
  }

  &:only-child {
    left: auto;
    right: -1px;
  }

  &:hover {
    color: ${({ theme }) => theme.mainColor};
  }
`;
